module.exports = __webpack_public_path__ + "img/login1.3a8f0e5.png";